import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../constants/media';
import { IServicePlanCards } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import RichTextTitle from '../base/richTextTitle';
import PlanCard from '../cards/planCard';
import TextLinkWithArrow from '../textLinkWithArrow';

const Root = styled.div<{ bottomLinkAvailable: boolean }>`
	margin-top: 150px;
	margin-bottom: ${({ bottomLinkAvailable }) => !bottomLinkAvailable && '-3rem'};
`;

const TitleAndLinkContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const RichTextTitleStyled = styled(RichTextTitle)`
	align-self: flex-start;

	${media.desktopSmall`
        align-self: center;
        text-align: center;
    `}
`;

const ColumnsStyled = styled(Columns)`
	justify-content: center;
	width: calc(100% + 3rem);
	padding-top: 56px;

	${media.desktopSmall`
		padding-top: 64px;
    `}
`;

const ColumnStyled = styled(Column)`
	display: flex;
	margin-bottom: 3rem;
`;

const LinkContainer = styled.div`
	margin-top: 8px;
	align-self: flex-end;

	${media.desktopSmall`
        margin-top: 0;
    `}
`;

interface Props {
	content: IServicePlanCards;
}

const ServicePlans: FC<Props> = ({ content }) => {
	return (
		<Root bottomLinkAvailable={!!content.Values.BottomLink}>
			<ContentContainer>
				<TitleAndLinkContainer>
					<RichTextTitleStyled content={content.Values.Title} type="h3" />
					<ColumnsStyled>
						{content.Values.Cards.map((card, idx) => (
							<ColumnStyled
								key={idx}
								tablet={1 / 2}
								desktopSmall={content.Values.Cards.length > 2 ? 1 / 3 : 1 / 2}>
								<PlanCard content={card} cardMinHeight={content.Values.CardsMinHeight} />
							</ColumnStyled>
						))}
					</ColumnsStyled>
					{content.Values.BottomLink && (
						<LinkContainer>
							<TextLinkWithArrow
								href={content.Values.BottomLink.Url}
								title={content.Values.BottomLink.Name}
							/>
						</LinkContainer>
					)}
				</TitleAndLinkContainer>
			</ContentContainer>
		</Root>
	);
};

export default ServicePlans;
